// Helper/auth.js
import { supabase } from "../supabaseClient";

export const getToken = async () => {
  const {
    data: { session },
    error,
  } = await supabase.auth.getSession();

  if (error) {
    console.error("Session error:", error);
    return null;
  }

  return session?.access_token || null;
};
